<template>
    <div>
        <v-layout row wrap>

            <v-flex xs12 lg10 offset-lg1>
                <p class="body-1 grey--text text--darken-1">{{ $t('title.ownedDemands')}}</p>
                <div v-show="loadingOwner">
                    <v-progress-circular v-bind:size="30" indeterminate class="secondary--text"></v-progress-circular>
                </div>
                <v-data-table v-bind:headers="ownedHeaders" :items="ownedDemands" hide-actions class="elevation-1" :no-data-text="$t('message.warning.noData')" :pagination.sync="pagination" :rows-per-page-items="[500]" v-if="!loadingOwner">
                    <template slot="items" slot-scope="{item}">
                        <router-link :to="{ name: 'demandEdit', params: { id: item.id } }" tag="tr">
                            <td class="demand-code">{{ item.code }}</td>
                            <td class="system-acronym">{{ item.system.acronym }}</td>
                            <td class="situation-name">{{ item.status.name }}</td>
                            <td>{{ item.type.name }}</td>
                            <td>{{ item.lastFlowDate | dateToLongString }}</td>
                            <td>{{ item.title }}</td>
                        </router-link>
                    </template>
                </v-data-table>
            </v-flex>

            <v-flex xs12 lg10 offset-lg1>
                <p class="body-1 grey--text text--darken-1 mt-5">{{ $t('title.requestedDemands')}}</p>
                <div v-show="loadingRequester">
                    <v-progress-circular v-bind:size="30" indeterminate class="secondary--text"></v-progress-circular>
                </div>
                <v-data-table v-bind:headers="createdHeaders" :items="requestedDemands" hide-actions class="elevation-1" :no-data-text="$t('message.warning.noData')" :pagination.sync="pagination" :rows-per-page-items="[500]" v-if="!loadingRequester">
                    <template slot="items" slot-scope="{item}">
                        <router-link :to="{ name: 'demandEdit', params: { id: item.id } }" tag="tr">
                            <td class="demand-code">{{ item.code }}</td>
                            <td class="system-acronym">{{ item.system.acronym }}</td>
                            <td class="situation-name">{{ item.status.name }}</td>
                            <td>{{ item | demandOwner}}</td>
                            <td>{{ item.title }}</td>
                        </router-link>
                    </template>
                </v-data-table>
            </v-flex>

            <v-flex xs12 lg10 offset-lg1>
                <p class="body-1 grey--text text--darken-1 mt-5">{{ $t('title.createdDemands')}}</p>
                <div v-show="loadingCreator">
                    <v-progress-circular v-bind:size="30" indeterminate class="secondary--text"></v-progress-circular>
                </div>
                <v-data-table v-bind:headers="requestedHeaders" :items="createdDemands" hide-actions class="elevation-1" :no-data-text="$t('message.warning.noData')" :pagination.sync="pagination" :rows-per-page-items="[500]" v-if="!loadingCreator">
                    <template slot="items" slot-scope="{item}">
                        <router-link :to="{ name: 'demandEdit', params: { id: item.id } }" tag="tr">
                            <td class="demand-code">{{ item.code }}</td>
                            <td class="system-acronym">{{ item.system.acronym }}</td>
                            <td class="situation-name">{{ item.status.name }}</td>
                            <td>{{ item.requester.name}}</td>
                            <td>{{ item.title }}</td>
                        </router-link>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
    </div>
</template>

<script>
import constants from '@/helpers/constants';
import CardLoader from '@/components/shared/CardLoader';

export default {
    data() {
        return {
            constants,
            pagination: {
                descending: true,
                sortBy: 'code',
            },
            ownedHeaders: [
                {
                    text: this.$t('label.code'),
                    value: 'code',
                    align: 'left',
                },
                {
                    text: this.$t('label.system'),
                    value: 'system.acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.status'),
                    value: 'status.id',
                    align: 'left',
                },
                {
                    text: this.$t('label.demandType'),
                    value: 'type.name',
                    align: 'left',
                },
                {
                    text: this.$t('label.receivedDate'),
                    value: 'creator.name',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'title',
                    align: 'left',
                },
            ],
            createdHeaders: [
                {
                    text: this.$t('label.code'),
                    value: 'code',
                    align: 'left',
                },
                {
                    text: this.$t('label.system'),
                    value: 'system.acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.status'),
                    value: 'status.id',
                    align: 'left',
                },
                {
                    text: this.$t('label.owner'),
                    value: 'owner.name',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'title',
                    align: 'left',
                },
            ],
            requestedHeaders: [
                {
                    text: this.$t('label.code'),
                    value: 'code',
                    align: 'left',
                },
                {
                    text: this.$t('label.system'),
                    value: 'system.acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.status'),
                    value: 'status.id',
                    align: 'left',
                },
                {
                    text: this.$t('label.requester'),
                    value: 'requester.name',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'title',
                    align: 'left',
                },
            ],
            requestedDemands: [],
            createdDemands: [],
            ownedDemands: [],
            loadingRequester: false,
            loadingOwner: false,
            loadingCreator: false,
            demands: this.$store.getters.demandsValueText,
            demandId: null,
        };
    },

    computed: {
        owned() {
            const person = this.$store.getters.profile.person;

            const approvers = this.$store.getters.systems.map(({ approvers }) => approvers)
            .reduce(
            // agrupa em um array só todos os aprovadores
                (arr, currValue) => arr.concat(currValue), [])
            // filtra pelo usuario
            .filter(apr => apr.person.id === person.id);
            // retorna as demandas que o usuário é aprovador na etapa que a demanda se encontra
            return this.$store.getters.demands.filter(demand =>
                demand.status.id < constants.STATUS_REJECTED
                && (demand.owner.id === person.id
                || approvers.findIndex(approver => approver.system.id === demand.system.id
                && approver.type.id === demand.ownerType) !== -1),
            );
            // return this.$store.getters.demands.filter(demand =>
            //     demand.owner.id === person.id &&
            //     demand.status.id < constants.STATUS_REJECTED,
            //  );
        },
        created() {
            const person = this.$store.getters.profile.person;
            return this.$store.getters.demands.filter(demand =>
                demand.creator.id === person.id &&
                demand.requester.id !== person.id &&
                demand.status.id < constants.STATUS_REJECTED,
            );
        },
        requested() {
            const person = this.$store.getters.profile.person;
            return this.$store.getters.demands.filter(demand =>
                demand.requester.id === person.id && demand.status.id < constants.STATUS_REJECTED,
            );
        },
    },
    components: {
        appCardLoader: CardLoader,
    },
    methods: {
        async demandasPorSolicitante() {
            this.loadingRequester = true;
            const person = this.$store.getters.profile.person;
            const res = await this.$store.dispatch('findDemandByRequest', person.id);
            this.requestedDemands = res.data.output;
            this.loadingRequester = false;
        },

        async demandasPorCriador() {
            this.loadingCreator = true;
            const person = this.$store.getters.profile.person;
            const res = await this.$store.dispatch('findDemandByCreator', person.id);
            this.createdDemands = res.data.output;
            this.loadingCreator = false;
        },
        async demandasPorResponsavel() {
            this.loadingOwner = true;
            const person = this.$store.getters.profile.person;
            const res = await this.$store.dispatch('findDemandByOwner', person.id);
            this.ownedDemands = res.data.output;
            this.loadingOwner = false;
        },
    },
    beforeMount() {
        this.demandasPorSolicitante();
        this.demandasPorCriador();
        this.demandasPorResponsavel();
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Index.vue